export default __webpack_public_path__ + "static/amin-worldwide-logo-b6aaa3e52385224a9ecdf89f0638db3d.svg";